import { Badge, styled } from '@mui/material';

import { palette } from '@setup/theme/palette';

import type { SizeBadge } from './MuiBadge';
import type { BadgeProps } from '@mui/material';

type ShouldForwardPropsType = {
  size?: SizeBadge;
  disableBackground?: boolean;
  badgeVariant: BadgeProps['variant'];
};

export const CustomBadge = styled(Badge, {
  shouldForwardProp: (prop: string) => !['size', 'disableBackground', 'badgeVariant'].includes(prop),
})<ShouldForwardPropsType>(({ theme, size, badgeVariant, disableBackground }) => ({
  ...(size === 'small' && {
    '& .MuiBadge-badge': {
      fontSize: theme.typography.t10m.fontSize,
      fontWeight: theme.typography.t10m.fontWeight,
      lineHeight: theme.typography.t10m.lineHeight,
      color: theme.palette.case.neutral.n900,
      padding: badgeVariant === 'dot' ? '0px' : '0 4px',
    },
    '& .MuiBadge-dot': {
      height: '6px',
      width: '6px',
      minWidth: '6px',
      minHeight: '6px',
    },
    '& .MuiBadge-standard': {
      minWidth: '16px',
      height: '16px',
      minHeight: '16px',
      '&.MuiBadge-colorError': {
        background: palette.case.red.r500,
        color: palette.case.neutral.n0,
      },
    },
  }),

  ...(disableBackground && {
    '& .MuiBadge-badge': {
      background: 'transparent',
    },
  }),
}));
